import businessStyles from '../../../../styles';

export default {
  item: {
    width: '33%',
    '@media screen and (max-width: 600px)': {
      width: '100%',
    },
  },
  optionalItem: {
    width: '50%',
    '@media screen and (max-width: 600px)': {
      width: '100%',
    },
  },
  identityRow: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '5px',
    '@media screen and (max-width: 600px)': {
      flexDirection: 'column',
    },
  },
  optionalRow: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '5px',
    margin: '7px 0',
    position: 'relative',
    '@media screen and (max-width: 600px)': {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  deleteIcon: {
    right: '-30px',
    top: '50%',
    cursor: 'pointer',
    position: 'absolute',
    transform: 'translateY(-50%)',
    '@media screen and (max-width: 600px)': {
      right: 0,
      top: 0,
      transform: 'none',
    },
  },
  ssnOrTinInput: businessStyles.ssnOrTinInput,
  datePickerContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flex: '0',
    '@media screen and (max-width: 600px)': {
      width: '100% !important',
      maxWidth: '100% !important',
      flexBasis: '100% !important',
    },
  },
  datePickerLabel: {
    fontSize: '12px',
    color: 'rgba(0, 0, 0, 0.54)',
    position: 'absolute',
    top: '-8px',
    left: '8px',
    height: '16px',
    zIndex: '1',
    background: '#ffffff',
    padding: '0 5px',
  },
  datePicker: {
    height: '56px',
    '@media screen and (max-width: 600px)': {
      width: '100%',
    },
  },
};
